import Vue from 'vue'
function loadScript(url){
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = () => {
            resolve();
        };
        document.head.appendChild(script);
    });
}
async function loadComponents(){
    // 获取当前时间戳
    const timestamp = Math.floor(Date.now() / 1000);
    const timestampOneHour = Math.floor(timestamp / 3600);

    //加载css+时间
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = "text/css";
    link.href = `https://remaker.ai/userspace/pai-components/pai-components.css?v=${timestampOneHour}`;
    document.head.appendChild(link);

    window.KODEPAY_APPLICATION_ID = "e23797ba-408b-11ee-ac3d-8aab52088258"; // application_id
    window.KODEPAY_CLIENT_ID = "f2ad3314-42ef-11ee-8ff7-2668ac0df4c0"; //client_id
    window.KODEPAY_ENV = "production"; //env，development 和  production

    // 加载外部资源+时间
    await Promise.all([
        loadScript(`https://remaker.ai/userspace/pai-components/pai-components.js?v=${timestampOneHour}`),
        loadScript('https://remaker.ai/userspace/pai-components/kodepay-website.js'),
    ]);


    // //加载页面脚本
    // const script3 = document.createElement('script');
    // script3.src = 'https://remaker.ai/userspace/saasbox/seo-html-tool/slider-two-img.js';
    // document.head.appendChild(script3);

    // const script4 = document.createElement('script');
    // script4.src = 'https://remaker.ai/userspace/saasbox/seo-html-tool/carousel.js';
    // document.head.appendChild(script4);

    // const script5 = document.createElement('script');
    // script5.src = 'https://remaker.ai/userspace/saasbox/seo-html-tool/footer.js';
    // document.head.appendChild(script5);
    // https://remaker.ai/userspace/saasbox/seo-html-tool/seo-html-tool-new.css
    // const link2 = document.createElement('link');
    // link2.rel = 'stylesheet';
    // link2.type = "text/css";
    // link2.href = 'https://remaker.ai/userspace/saasbox/seo-html-tool/seo-html-tool-new.css';
    // document.head.appendChild(link2);

}
export default async () => {
    window.Vue = Vue;
    // 动态加载外部 JS 文件
    await loadComponents()
  }